import React from 'react';

export const NIKEONE = {
    sportIcon: false,
    shortcutMarkets: true,
    editorTips: false,
    live: true,
    prematch: true,
    results: true,
    usePrematchOnly: true
};
export const SINGLE_TOURNAMENT = {
    sportIcon: true,
    shortcutMarkets: true,
    editorTips: false,
    live: false,
    prematch: true,
    results: true,
    dates: true
};
export const SEARCH_LIVE = {
    sportIcon: false,
    shortcutMarkets: false,
    editorTips: false,
    live: true,
    prematch: false,
    results: false
};
export const SEARCH_TOURNAMENTS = {
    sportIcon: false,
    shortcutMarkets: false,
    editorTips: false,
    live: true,
    prematch: true,
    results: true
};
export const SEARCH_PREMATCH = {
    sportIcon: false,
    shortcutMarkets: false,
    editorTips: false,
    live: false,
    prematch: true,
    results: false
};
export const SEARCH_RESULT = {
    sportIcon: false,
    shortcutMarkets: false,
    editorTips: false,
    live: false,
    prematch: false,
    results: true
};
export const ARTICLE = {
    sportIcon: false,
    shortcutMarkets: false,
    editorTips: true,
    live: true,
    prematch: true,
    results: true
};
export const HOMEPAGE = {
    sportIcon: true,
    shortcutMarkets: false,
    editorTips: false,
    live: false,
    prematch: true,
    results: false
};

export const BETBOOK = {
    sportIcon: true,
    shortcutMarkets: false,
    editorTips: true,
    live: true,
    prematch: true,
    results: true,
    moreOptions: false,
    editorTipAlwaysVisible: true
};

export default React.createContext(NIKEONE);
